import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '@/shared/hooks/use-session';
import { ADMIN_ROUTES, DASHBOARD_ROUTES } from '@/api/constants/app.url';
import { isAddAccountSearch } from '@/modules/accounts';

/**
 * Inverse of `ProtectedRoute` — routes that should be unreachable to a user
 * who already has a session. Used for /sign-in and the signup funnel so a
 * logged-in user can't accidentally restart the wizard or trigger a second
 * sign-in.
 *
 * Bounces to /home (same destination ProtectedRoute uses on a role miss).
 */
export function PublicOnlyRoute() {
    const { session, isLoading } = useSession();
    const { search } = useLocation();

    // Mirror ProtectedRoute's loading gate so a future async auth provider
    // (Clerk) drops in without flicker.
    if (isLoading) return null;

    // "Add account" deliberately opens sign-in while a session is live — that
    // is the whole point of the flow, so it is the one case that passes.
    if (session && !isAddAccountSearch(search)) {
        return <Navigate to={session.role === 'super_admin' ? ADMIN_ROUTES.INSIGHT : DASHBOARD_ROUTES.HOME} replace />;
    }

    return <Outlet />;
}
